import axios from 'axios';
import axiosClient from './axiosClient';
import AppConfigs from 'general/constants/AppConfigs';

const miscApi = {
  // upload anh
  uploadFile: (file) => {
    const url = '/media/upload';
    const formData = new FormData();
    formData.append('files', file);
    return axiosClient.post(url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  // lay config
  getConfig: () => {
    const url = '/config';
    return axiosClient.get(url, {
      headers: { 'Content-Type': 'application/json' },
    });
  },
  // them config
  addConfig: (params) => {
    const url = '/config';
    return axiosClient.post(url, params);
  },
  // lay ds VietQR banks
  getBankList: () => {
    const url = process.env.REACT_APP_LISTS_BANK_URL;
    return axiosClient.get(url, {});
  },

  // lay ds ngan hang
  getBanksList: (params) => {
    const url = `${AppConfigs.env.baseUrl}api/v1/misc/banks`;
    return axios.get(url, { params });
  },
};

export default miscApi;
